module.exports = __webpack_public_path__ + "img/fixtures.67f03918.svg";